import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import { Link } from "gatsby-plugin-intl"
import { VideoBg } from "../"

import logo from "../../images/logo-white.svg"
import './outdoor.scss'
import './animated-arrow-left.scss'

const HomeOutdoor = ( { intl } ) => {
  return (
    <div className="outdoor">
      <div className="logo-wrapper">
        <embed src={ logo } alt="Try" />
      </div>
      <div className="description">
        <div className="title">
          { intl.formatMessage( { id: "home.title" } ) } <br/>
          <strong> { intl.formatMessage( { id: "home.subtitle" } ) } </strong>
        </div>
        <Link className="button" to="/about">{ intl.formatMessage( { id: "home.about-button" } ) }</Link>
          {/*<div id="scroll-down">
            <span class="arrow-down">
              
            </span>
  <span id="scroll-title">*/}
              
           {/* </span>
          </div>*/}
        
      </div>
      <VideoBg title="Try" videoId="376897216" />
    </div>
  )
}

const injected = injectIntl( HomeOutdoor )
export { injected as HomeOutdoor }
